var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1870_12570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.3815 13.7305L9.48476 21.1928L13.5253 17.3062L20.4362 22.5901L25.4512 1.86328L0.451172 11.514L6.3815 13.7305ZM4.43162 11.4929L16.348 6.89276L6.87169 12.4049L4.43162 11.4929ZM18.4714 7.30115L10.5622 14.261L9.61083 17.7096L7.8513 13.4786L18.4714 7.30115ZM11.1545 17.5977L11.6338 15.8601L12.3732 16.4254L11.1545 17.5977ZM19.5361 20.1055L12.3395 14.6032L23.1746 5.06858L19.5361 20.1055Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1870_12570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.e339918d0c5b9ee41346cee669e39531.svg";
export { ForwardRef as ReactComponent };